<!-- eslint-disable max-len -->
<template>
  <div class="form-page-detail-body-container">
    <div class="w-100 d-flex justify-content-end mb-3">
      <button
        v-if="showBtnUpdateTable"
        class="form-page-detail-button"
        @click="openModalUpdateTable($v.workflow)">
        Save
      </button>
    </div>

    <div class="workflow-data-container">
      <b-row>
        <b-col md="6">
          <h4>Standard Workflow</h4>
        </b-col>
        <b-col md="6">
          <img
            :src="require(`@/assets/form-data/${workflowActive === 'standard' ? 'on' : 'off'}.png`)"
            class="pull-right cursor-pointer"
            @click="workflowActive = 'standard';
                    setChangesValueView(true);">
        </b-col>
      </b-row>

      <div v-show="workflowActive === 'standard'">
        <b-form-group
          :class="{'error-input' : $v.workflow.defaultRule.$error}"
          class="m__b--15"
          style="width: 99%">
          <label>Default Rule </label>
          <j-single-select
            v-model="$v.workflow.defaultRule.$model"
            :error-required="$v.workflow.defaultRule.$error"
            :is-async="true"
            :cache-options="false"
            :load-options="loadOptionsRule"
            :placeholder="'Select Default Rule'"
            value-format="object"
            label="name"
            @input="changeRule"/>
        </b-form-group>

        <div class="m__b--5">Exception Rule</div>
        <div class="d-flex">
          <b-button
            id="privilegeForm"
            class="btn grey btn-import-form m__r--5">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <j-input
            v-model="search"
            :error-required="false"
            placeholder="Search"
            style="width: 250px"/>
        </div>
        <div class="list-rule">
          <div
            v-for="(value, index) in dataRuleFiltered"
            :key="index"
            class="rectangle-rule">
            <b-row>
              <b-col md="1">
                <img
                  v-if="value.user.photo_url"
                  :title="value.user.first_name"
                  :src="value.user.photo_url"
                  class="card-assignee-photo-modal">
                <span
                  v-else
                  :title="value.user.first_name"
                  class="card-assignee-initial-modal">
                  {{ getUserInitial(value.user) }}
                </span>
              </b-col>
              <b-col md="4">
                {{ value.user.first_name }} {{ value.user.last_name }} <br>
                <span class="label-position">{{ value.organigram_name }}</span>
              </b-col>
              <b-col md="5">
                <div v-if="value.type === 'rule'">
                  RULE <br>
                  {{ value.rule.name }}
                </div>
                <div v-else>AUTO APPROVE</div>
              </b-col>
              <b-col md="2">
                <span
                  class="cursor-pointer pull-right"
                  @click="deleteRule(value, index)">
                  <i class="fa fa-trash fa-2x"/>
                </span>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <div class="workflow-data-container">
      <b-row>
        <b-col md="6">
          <h4>Advance Workflow</h4>
        </b-col>
        <b-col md="6">
          <img
            :src="require(`@/assets/form-data/${workflowActive === 'dynamic' ? 'on' : 'off'}.png`)"
            class="pull-right cursor-pointer"
            @click="workflowActive = 'dynamic';
                    setChangesValueView(true);">
        </b-col>
      </b-row>

      <div v-show="workflowActive === 'dynamic'">
        Approver Selection
        <div class="d-flex">
          <div
            :class="approvalSelection === 'manual' ? 'option-active' : ''"
            class="container-option-flow manual-flow m__r--10"
            @click="approvalSelection = 'manual';
                    setChangesValueView(true);">
            <span class="text-option">Manual</span>
          </div>
          <div
            :class="approvalSelection === 'function' ? 'option-active' : ''"
            class="container-option-flow"
            @click="approvalSelection = 'function';
                    setChangesValueView(true);">
            <span class="text-option">Function</span><br>
            <span class="text-option-small">Visual Programming</span>
          </div>
        </div>

        <div
          v-if="approvalSelection === 'manual'"
          class="m__t--15">Type</div>
        <div
          v-if="approvalSelection === 'manual'"
          class="d-flex">
          <div
            :class="manualSelection === 'by_organigram' ? 'option-active' : ''"
            class="container-option-flow manual-flow manual-by-flow m__r--10"
            @click="manualSelection = 'by_organigram';
                    setChangesValueView(true);">
            <span class="text-option">by Organigram</span>
          </div>
          <!-- Disable dulu sementara -->
          <div
            class="container-option-flow manual-flow manual-by-flow"
            style="cursor: no-drop">
            <span class="text-option">by Flow</span><br>
          </div>
          <!-- <div
            :class="manualSelection === 'by_flow' ? 'option-active' : ''"
            class="container-option-flow manual-flow manual-by-flow"
            @click="manualSelection = 'by_flow';
                    setChangesValueView(true);">
            <span class="text-option">by Flow</span><br>
          </div> -->
        </div>

        <b-form-group
          v-if="approvalSelection === 'function'"
          :class="{'error-input' : $v.workflow.function_name.$error}"
          class="m__t--15">
          <label> Function Name </label>
          <j-single-select
            v-model="$v.workflow.function_name.$model"
            :error-required="$v.workflow.function_name.$error"
            :options="listFunction"
            :placeholder="'Select Function Name'"
            label="name"
            @input="changeFunction"/>
        </b-form-group>
      </div>
    </div>

    <!-- <b-col cols="12">
      <b>Set Rule Workflow</b>
      <b-row>
        <b-col md="2">
          <b-form-group :class="{'error-input' : $v.workflow.isUseWorkflow.$error}">
            <label> Use Workflow </label>
            <j-toggle v-model="workflow.isUseWorkflow"/>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :class="{'error-input' : $v.workflow.defaultRule.$error}">
            <label>Default Rule </label>
            <j-single-select
              v-model="$v.workflow.defaultRule.$model"
              :error-required="$v.workflow.defaultRule.$error"
              :is-async="true"
              :cache-options="false"
              :load-options="loadOptionsRule"
              :placeholder="'Select Default Rule'"
              value-format="object"
              label="name"/>
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          class="p__l--1">
          <b-button
            class="btn blue m__t--27"
            @click="applyForm">
            Apply
          </b-button>
        </b-col>
      </b-row>

      Exception Rule
      <b-row>
        <b-col md="6">
          <j-input
            v-model="search"
            :error-required="false"
            :max-length="255"
            placeholder="Search"/>
        </b-col>
        <b-col
          md="6"
          class="p__l--1">
          <b-button
            id="privilegeForm"
            class="btn blue">
            Add
          </b-button>
        </b-col>
      </b-row>
      <div class="list-rule">
        <div
          v-for="(value, index) in dataRuleFiltered"
          :key="index"
          class="rectangle-rule">
          <b-row>
            <b-col md="1">
              <img
                v-if="value.user.photo_url"
                :title="value.user.first_name"
                :src="value.user.photo_url"
                class="card-assignee-photo-modal">
              <span
                v-else
                :title="value.user.first_name"
                class="card-assignee-initial-modal">
                {{ getUserInitial(value.user) }}
              </span>
            </b-col>
            <b-col md="4">
              {{ value.user.first_name }} {{ value.user.last_name }} <br>
              <span class="label-position">{{ value.organigram_name }}</span>
            </b-col>
            <b-col md="5">
              <div v-if="value.type === 'rule'">
                RULE <br>
                {{ value.rule.name }}
              </div>
              <div v-else>AUTO APPROVE</div>
            </b-col>
            <b-col md="2">
              <span
                class="cursor-pointer pull-right"
                @click="deleteRule(value, index)">
                <i class="fa fa-trash fa-2x"/>
              </span>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-col> -->

    <b-popover
      ref="popoverAddBoardAssignee"
      :show.sync="popoverPrivilegeForm"
      target="privilegeForm"
      triggers="click"
      placement="left"
      container="privilege-setting-container">
      <h3>Add Rule Workflow</h3>
      <b-form-group
        :class="{'error-input' : $v.dataPrivilege.position.$error}">
        <label for="position">Position</label>
        <j-single-select
          id="position"
          v-model="dataPrivilege.position"
          :is-async="true"
          :cache-options="false"
          :load-options="loadOptionsPosition"
          :placeholder="'Select Position'"
          value-format="object"
          label="name"/>
      </b-form-group>
      <b-form-group>
        <label>Without Approver</label>
        <j-toggle
          v-model="dataPrivilege.withoutApprover"/>
      </b-form-group>
      <b-form-group
        v-if="!dataPrivilege.withoutApprover"
        :class="{'error-input' : $v.dataPrivilege.rule.$error}">
        <label for="rule">Rule</label>
        <j-single-select
          id="rule"
          v-model="dataPrivilege.rule"
          :is-async="true"
          :cache-options="false"
          :load-options="loadOptionsRule"
          :placeholder="'Select Rule'"
          value-format="object"
          label="name"/>
      </b-form-group>

      <b-button
        class="btn"
        @click="popoverPrivilegeForm = false">
        Close
      </b-button>
      <b-button
        class="btn blue"
        @click="addPrivilegeForm">
        Add
      </b-button>
    </b-popover>

    <j-modal-update-table
      v-if="isShowModalUpdateTable"
      id="modalUpdateTableId"
      :table-name="form_data.name"
      @submit="handleSubmitForm"
      @close="closeModalUpdateTable"
    />
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-console, no-unused-vars */
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapState, mapActions, mapMutations } from 'vuex';
import jwtDecode from 'jwt-decode';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import jMixModalUpdateTable from '@/mixins/jMixModalUpdateTable';
import jModalUpdateTable from '@/views/data-manager/jModalUpdateTable';

export default {
  // eslint-disable-next-line
  name: 'jFormWorkflow',
  components: {
    jModalUpdateTable,
  },
  mixins: [jMixModalUpdateTable],

  data() {
    return {
      workflow: {
        defaultRule: null,
        isUseWorkflow: false,
        function_name: null,
      },
      dataPrivilege: {
        position: null,
        rule: null,
        withoutApprover: true,
      },
      popoverPrivilegeForm: false,
      workflowActive: '',
      approvalSelection: '',
      manualSelection: '',
      search: '',
      dataRuleOriginal: [],
      dataRuleFiltered: [],
      listFunction: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },
  computed: {
    ...mapState('jStoreForm', ['form_data', 'privilege_by_me']),

    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },

    showBtnUpdateTable() {
      return this.isAdmin || (this.privilege_by_me.includes('alter_table') && !this.privilege_by_me.includes('view_only'));
    },
  },
  watch: {
    search(val) {
      this.dataRuleFiltered = this.dataRuleOriginal.filter(priv =>
        priv.organigram_name.toUpperCase().includes(val.toUpperCase())
          || priv.user.first_name.toUpperCase().includes(val.toUpperCase())
          || priv.user.last_name.toUpperCase().includes(val.toUpperCase()));
    },

    // eslint-disable-next-line
    'workflow.isUseWorkflow': function() {
      // this.submitForm();
    },

    form_data(val) {
      if (val.is_use_workflow) {
        this.dataRuleOriginal = Object.values(val.workflow.by_organigram_id);
        this.dataRuleFiltered = Object.values(val.workflow.by_organigram_id);

        this.workflow.isUseWorkflow = val.is_use_workflow;
        this.workflowActive = val.workflow.type || 'standard';
        this.approvalSelection = val.workflow.approver_selection || '';
        this.workflow.function_name = val.workflow.function_name || null;
        this.manualSelection = val.workflow.approver_by || '';

        if (val.workflow.default_rule.rule_id !== 0) {
          const paramRule = {
            pagination: {
              limit: 10,
              page: 1,
              column: 'id',
              ascending: true,
              query: val.workflow.default_rule.rule_id,
              query_type: 'id',
            },
          };
          this.findRule(paramRule).then((resRule) => {
            const dataRule = resRule.data.find(e => e.id === val.workflow.default_rule.rule_id);
            if (dataRule) {
              dataRule.label = dataRule.name;
              this.workflow.defaultRule = dataRule || null;
            }
          });
        }
      }
    },
  },
  created() {
    this.setChangesValueView(false);
    this.getListFunction();
    if (this.form_data) {
      const reqTable = {
        tablegroup_id: this.$route.params.id,
        search: this.form_data.id,
      };
      this.findListTableByGroup(reqTable).then((res) => {
        if (res.data && res.data.length > 0) {
          const dataForm = res.data.find(f => f.id === this.form_data.id);
          this.actionSetFormData(dataForm);
        }
      });
    }
  },
  methods: {
    ...mapActions('jStoreForm', ['updateForm', 'findForm', 'actionSetFormData', 'actionSetForm', 'actionSetNameForm', 'findRule',
      'updateTable', 'findListTableByGroup']),
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),

    getUserInitial(user) {
      const firstName = user.first_name ? user.first_name[0] : '';
      const lastName = user.last_name ? user.last_name[0] : '';
      const initial = `${firstName}${lastName}`;
      return initial.toUpperCase();
    },

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },

    loadOptionsPosition({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: 'id',
              ascending: true,
              query: searchQuery,
              query_type: 'position',
            },
          };
          this.$store.dispatch('jStoreForm/getListPosition', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    loadOptionsRule({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: 'id',
              ascending: true,
              query: searchQuery,
              query_type: 'name',
            },
          };
          this.$store.dispatch('jStoreForm/getListRule', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    addPrivilegeForm() {
      this.$v.dataPrivilege.$touch();
      if (!this.$v.dataPrivilege.$invalid) {
        const data = {
          organigram_id: this.dataPrivilege.position.id,
          organigram_name: this.dataPrivilege.position.name,
          user: {
            first_name: this.dataPrivilege.position.user ? this.dataPrivilege.position.user.profile.first_name : '',
            last_name: this.dataPrivilege.position.user ? this.dataPrivilege.position.user.profile.last_name : '',
            photo_url: this.dataPrivilege.position.user ? this.dataPrivilege.position.user.profile.photo_url : '',
          },
          type: this.dataPrivilege.withoutApprover ? 'auto_approve' : 'rule',
        };
        if (this.dataPrivilege.withoutApprover) {
          data.rule_id = 0;
        } else {
          data.rule = {
            id: this.dataPrivilege.rule.id,
            name: this.dataPrivilege.rule.name,
          };
        }

        const findDuplicate = this.dataRuleOriginal.find(e => e.organigram_id === data.organigram_id);
        if (findDuplicate) {
          this.toggleProblem('Position cannot duplicate');
        } else {
          this.dataRuleOriginal.push(data);
          this.dataRuleFiltered.push(data);
          this.submitForm();
          this.popoverPrivilegeForm = false;
          this.dataPrivilege = {
            position: null,
            rule: null,
            withoutApprover: true,
          };
        }
      }
    },

    deleteRule(value, index) {
      this.dataRuleFiltered.splice(index, 1);
      const indexDeleted = this.dataRuleOriginal.findIndex(e => e.organigram_id === value.organigram_id);
      this.dataRuleOriginal.splice(indexDeleted, 1);

      this.submitForm();
    },

    applyForm() {
      this.$v.workflow.$touch();
      if (!this.$v.workflow.$invalid) {
        this.submitForm();
      }
    },

    getData() {
      const param = this._.cloneDeep(this.form_data);
      const workflow = {
        default_rule: {
          rule_id: this.workflowActive === 'standard' ? (this.workflow.defaultRule ? this.workflow.defaultRule.id : 0) : 0,
        },
        by_organigram_id: {},
        type: this.workflowActive,
        approver_by: this.workflowActive === 'dynamic' ? (this.approvalSelection === 'manual' ? this.manualSelection : '') : '',
        approver_selection: this.workflowActive === 'dynamic' ? this.approvalSelection : '',
        function_name: this.workflowActive === 'dynamic' && this.approvalSelection === 'function' ? this.workflow.function_name : '',
      };
      if (this.workflowActive === 'standard') {
        this.dataRuleOriginal.forEach((e) => {
          workflow.by_organigram_id[e.organigram_id] = e;
        });
      }
      param.is_use_workflow = !!this.workflowActive;
      param.workflow = workflow;
      delete param.columns;

      if (this.workflowActive === 'dynamic' && this.approvalSelection === '') {
        this.toggleProblem('Please select approval selection first');
        return false;
      } else if (this.workflowActive === 'dynamic' && this.approvalSelection === 'manual' && this.manualSelection === '') {
        this.toggleProblem('Please select by Organigram or by Flow first');
        return false;
      }
      return param;
    },

    switchForm(data, id, name) {
      this.actionSetFormData(data);
      this.actionSetForm(id);
      this.actionSetNameForm(name);
    },

    submitForm() {
      this.$v.workflow.$touch();
      if (!this.$v.workflow.$invalid) {
        const param = this.getData();
        const session = this.session;

        if (param) {
          // this.updateForm({ param, session }).then((response) => {
          //   if (response.error) {
          //     this.toggleProblem(response.message);
          //   } else {
          //     this.setChangesValueView(false);
          //     this.switchForm(response.data, response.data.id, response.data.name);
          //   }
          // });

          delete param.columns;
          this.updateTable({ param }).then((response) => {
            if (response.error) {
              this.toggleProblem(response.message);
            } else if (!response.error && response.error_session) {
              this.toggleInfo(response.message);
            } else {
              this.setChangesValueView(false);
              this.switchForm(response.data, response.data.id, response.data.name);
            }
          });
        }
      }
    },

    handleSubmitForm() {
      this.submitForm();
      this.closeModalUpdateTable();
    },

    changeRule(data) {
      if (this.form_data.workflow.default_rule.rule_id !== 0) {
        if (this.form_data.workflow.default_rule.rule_id !== data.id) {
          this.setChangesValueView(true);
        }
      } else {
        this.setChangesValueView(true);
      }
    },

    changeFunction(data) {
      if (this.form_data.workflow.function_name) {
        if (this.form_data.workflow.function_name !== data) {
          this.setChangesValueView(true);
        }
      } else {
        this.setChangesValueView(true);
      }
    },
  },
  validations() {
    return {
      workflow: {
        defaultRule: { },
        isUseWorkflow: { },
        function_name: {
          required: requiredIf(() => this.approvalSelection === 'function'),
        },
      },
      dataPrivilege: {
        position: { required },
        rule: {
          required: requiredIf(() => !this.dataPrivilege.withoutApprover),
        },
        withoutApprover: { },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .form-page-detail-body-container {
    width: 727px;
    overflow: auto;
    margin: 0px auto;
    height: auto;
    padding: 30px 15px;
  }

  .workflow-data-container {
    border-radius: 8px;
    border: solid 1px #f1f1f1;
    background-color: #ffffff;
    margin-bottom: 15px;
    padding: 15px;
    font-family: 'Poppins-Regular';
    font-size: 12px;
  }

  .container-option-flow {
    border-radius: 8px;
    border: solid 1px #f3f3f3;
    padding: 10px;
    margin-top: 10px;
    min-width: 200px;
    text-align: center;
    justify-content: center;

    .text-option {
      font-size: 18px;
      font-weight: bold;
    }

    .text-option-small {
      font-size: 12px;
      font-weight: bold;
    }

    &:hover{
      cursor: pointer;
      border: solid 1px #1a86e4;
    }
  }

  .manual-flow {
    padding-top: 20px !important;
  }

  .manual-by-flow {
    padding-bottom: 20px !important;
  }

  .rectangle-rule {
    height: 55px;
    width: 99%;
    margin: 10px 0 10px 0;
    padding: 10px;
    border-radius: 8px;
    border: solid 1px #f1f1f1;
    background-color: #ffffff;

    font-family: 'Poppins-Regular';
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #808080;
  }

  .card-assignee-photo-modal {
    width: 35px;
    height: 35px;
    background-size: 120px;
    border: 0;
    border-radius: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .card-assignee-initial-modal {
    display: inline-block;
    background-color: gainsboro;
    color: grey;
    font-size: 18px;
    height: 35px;
    width: 35px;
    padding-top: 10px;
    margin-left: 3px;
    text-align: center;
    border-radius: 50%;
  }

  .label-position {
    font-family: Poppins-Medium;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #5b5a5a;
  }

  .list-rule {
    max-height: 325px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/data-manager/jFormWorkflow.vue